export default {
  buttons: {
    sign_in: 'Inloggen',
    sign_up: 'Registreren',
    logout: 'Uitloggen',
  },
  logout_confirm: {
    title: 'Uitloggen?',
    description: 'Weet je zeker dat je wilt uitloggen?',
    cancel: 'Annuleren',
    confirm: 'Uitloggen',
  },
};
